import React, { useState, useEffect } from "react";
import {
   isActivePublicUser,
   getConnectionData,
   addConnectionsToActionButtons,
} from "../../../../util/Scripts";
import { DragDropContext } from "react-beautiful-dnd";
import { transformFormValuesForRequest } from "../../../FormsV2/GeneralScripts";
import { getListExcel, getListProfiles, getListV2 } from "../../../../services/api/Api";
import { useDispatch, useSelector } from "react-redux";
import { getForm, saveFormV2 } from "../../../../services/restAPI/RestApi";
import { KanbanScripts } from "./KanbanScripts";
import { updateSearchParams } from "../../../../appRedux/actions/Setting";
import { useIntl } from "react-intl";
import { Message, Button, Spin, Empty } from "../../../BP2Components";
import KanbanSettingsModal from "../../WidgetsSettings/KanbanSettings/KanbanSettingsModal";
import KanbanViewSettings from "./kanbanViewSettings";
import SettingsModal from "../../../Modal/SettingsModal";
import Widget from "../../../Widget/Widget";
import "./kanban.less";
import KanbanColumn from "./KanbanColumn";
import { useEffectPlus } from "../../../../util/customHooks";
import { Icon_ChevronLeft, Icon_ChevronRight } from "../../../BP2Components/Icons/icons";
import { getListV3, getProfiles } from "../../../../services/restAPI/ListsV2";
import {
   getFormStructure,
   getFormWithData,
   getV3DataUrl,
   postFormData,
} from "../../../../services/restAPI/FormsV3";

const KanbanWidget = ({ value: widgetData, role }) => {
   const [renderedColumns, setRenderedColumns] = useState([]);
   const [columns, setColumns] = useState([]);
   const [rows, setRows] = useState([]);
   const [displayFormChildId, setDisplayFormChildId] = useState();
   const [formKey, setFormKey] = useState(null);
   const [previewItemFormChildId, setPreviewItemFormChildId] = useState();
   const [loading, setLoading] = useState(true);
   const [mobileView, setMobileView] = useState();
   const { currentBoard } = useSelector(({ boards }) => boards);
   const intl = useIntl();
   const { search } = useSelector(({ settings }) => settings);
   const [actionButtons, setActionButtons] = useState([]);
   const [fetchedProfiles, setFetchedProfiles] = useState(false);
   const [selectedProfile, setSelectedProfile] = useState();
   const [areInstancesIncluded, setAreInstancesIncluded] = useState(false);
   const isV3 = widgetData.listId?.toString().length > 10;

   const [viewSettings, setViewSettings] = useState({
      enableEditByMovingElements: true,
      sortColumnsBy: widgetData?.horizontalPlacement,
      sortColumns: widgetData?.sortColumns,
      sortRowsBy: widgetData?.verticalPlacement,
      sortRows: widgetData?.sortRows,
   });

   const updateViewSettings = () => {
      setViewSettings({
         enableEditByMovingElements: viewSettings?.enableEditByMovingElements,
         sortColumnsBy: widgetData?.horizontalPlacement,
         sortColumns: widgetData?.sortColumns,
         sortRowsBy: widgetData?.verticalPlacement,
         sortRows: widgetData?.sortRows,
      });
   };

   const dispatch = useDispatch();

   // this function is passed to kanbanViewSettings, to claim data from profile select element, and set new profile.
   const selectProfile = (profile) => {
      // getting url, and decoding list`s profile, into an object
      const url = new URL(window.location);
      let listProfile = JSON.parse(decodeURIComponent(url.searchParams.get("listProfile")));

      setSelectedProfile(profile);

      // making new profile obj.
      listProfile = { [widgetData.id]: { profile: profile } };

      //setting new object into the url
      url.searchParams.set("listProfile", encodeURIComponent(JSON.stringify(listProfile)));
      window.history.replaceState({}, "", url);

      // dispatching new url, to trigger all fetching functions, and fetch list with new parameters
      dispatch(updateSearchParams(url.search));
   };

   const handleListResponse = (responseData, formStructure, listId) => {
      const columnsCopy = KanbanScripts.createColumnsFromResponse(
         responseData.columns,
         formStructure,
         listId,
      );
      setColumns(columnsCopy);

      const rowsCopy = KanbanScripts.createRowsFromResponse(
         responseData.data,
         columnsCopy,
         widgetData,
      );
      setRows(rowsCopy);
      // Here is connection between widgets handled
      let actions = addConnectionsToActionButtons(
         currentBoard?.connections,
         responseData.actions ?? responseData.meta.actions,
         widgetData.id,
         widgetData.listId,
         intl,
      );
      setActionButtons(actions?.length > 0 ? actions : responseData.actions);
      setDisplayFormChildId(
         responseData.meta.displayFormChildId
            ? Number(responseData.meta.displayFormChildId)
            : responseData.meta.global.presenterFormId,
      );
      setPreviewItemFormChildId(
         responseData.meta.previewItemFormChildId
            ? Number(responseData.meta.displayFormChildId)
            : responseData.meta.global.presenterFormId,
      );
      setFormKey(responseData.meta.keys[responseData.meta.previewItemFormChildId]);
      setAreInstancesIncluded(
         responseData.columns.findIndex((column) => column.label === "api_instanceStatus") != -1,
      );

      setLoading(false);
   };

   const onDragEnd = (result) => {
      let { source, destination } = result;

      if (
         !destination ||
         (source.index == destination.index && source.droppableId == destination.droppableId)
      ) {
         return;
      }

      const sourceColumn = [...renderedColumns.find(([id]) => id == source.droppableId)];
      const destinationColumn = [...renderedColumns.find(([id]) => id == destination.droppableId)];
      const sourceItems = [...sourceColumn[1].items];
      let [removed] = sourceItems.splice(source.index, 1);
      const destinationItems =
         source.droppableId === destination.droppableId
            ? sourceItems
            : [...destinationColumn[1].items];

      if (
         !(
            !!widgetData.blockHorizontalMovement && source.droppableId !== destination.droppableId
         ) &&
         !(
            !!widgetData.blockVerticalMovement &&
            source.index !== destination.index &&
            source.droppableId == destination.droppableId
         )
      ) {
         if (destinationItems.length !== 0 && viewSettings.enableEditByMovingElements) {
            removed = KanbanScripts.editMovedItemValue(
               widgetData,
               removed,
               destination,
               destinationItems,
               columns,
            );
         }
         if (source.droppableId !== destination.droppableId) {
            removed[KanbanScripts.getTitleFromTechName(viewSettings.sortColumnsBy, columns)] = {
               id: destination.droppableId,
               value: destinationColumn[1].name,
            };
         }
         setRenderedColumns((prev) => {
            const next = prev.map(([id, col]) => [id, { ...col, items: [...col.items] }]);
            const sourceIdx = next.findIndex(([id]) => String(id) === String(source.droppableId));
            const destinationIdx = next.findIndex(
               ([id]) => String(id) === String(destination.droppableId),
            );
            if (sourceIdx !== -1) {
               next[sourceIdx][1].items.splice(source.index, 1);
            }
            if (destinationIdx !== -1) {
               next[destinationIdx][1].items.splice(destination.index, 0, removed);
            }
            return next;
         });

         saveItemValue(removed);
      }
   };

   /**
    * Builds a map of { valueKey: label } either from static `.values`
    * or by fetching `.selectEntries` from the server.
    */
   async function buildValueMap(groupingCol, columnsForTech) {
      if (groupingCol.values) {
         // static mapping
         return groupingCol.values.reduce((map, entry) => {
            const [key, label] = Object.entries(entry)[0];
            map[key] = label;
            return map;
         }, {});
      }

      if (groupingCol.selectEntries) {
         try {
            const { data } = await getV3DataUrl(groupingCol.selectEntries);
            if (!Array.isArray(data)) return {};
            return data.reduce((map, { value, label }) => {
               map[value] = label;
               return map;
            }, {});
         } catch (err) {
            console.error("Error fetching selectEntries data:", err);
            return {};
         }
      }

      return {};
   }

   /**
    * Filters rows whose grouping-column cell matches the given label,
    * then sorts them by the specified row-sort key & type.
    */
   function filterAndSortRows(
      rows,
      groupingColTitle,
      valueKey,
      label,
      sortByTechName,
      columns,
      ascending,
   ) {
      // find the titles & enum once
      const rowTitle = KanbanScripts.getTitleFromTechName(sortByTechName, columns);
      const enumType = columns.find((c) => c.techName === sortByTechName)?.enumType;

      // filter
      let items = rows.filter((row) => {
         const cell = row[groupingColTitle];
         return cell?.value === label || cell === label;
      });

      // sort
      items.sort((a, b) => {
         let aVal = a[rowTitle]?.value ?? a[rowTitle];
         let bVal = b[rowTitle]?.value ?? b[rowTitle];

         if (enumType === "int" || enumType === "dec") {
            aVal = parseFloat(aVal);
            bVal = parseFloat(bVal);
         }

         const cmp = aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
         return ascending ? cmp : -cmp;
      });

      return items;
   }

   /**
    * Main: returns an array of [key, { name: label, items: [...] }] tuples.
    */
   async function createRenderedColumns(rows, columns) {
      const { sortColumnsBy, sortRowsBy, sortRows } = viewSettings;

      const groupingCol = columns.find(({ techName }) => techName === sortColumnsBy) || null;
      if (!groupingCol) return [];

      const valueMap = await buildValueMap(groupingCol, columns);
      if (Object.keys(valueMap).length === 0) return [];

      return Object.entries(valueMap).map(([key, label]) => {
         const items = filterAndSortRows(
            rows,
            groupingCol.title,
            key,
            label,
            sortRowsBy,
            columns,
            Boolean(sortRows),
         );
         return [key, { name: label, items }];
      });
   }

   const saveItemValue = async (item, fieldTechName) => {
      Message.loading(intl.formatMessage({ id: "form.isProcessing" }), 0);
      const prevRows = [...rows];
      setRows([...rows.filter(({ key }) => key != item.key), item]);
      const result = await getFormWithData(displayFormChildId, item?.recordId);
      const fieldProjectObj = result.data.fields.find(
         (field) => field.modelField.name === "project",
      );
      const dataProjectTechName = fieldProjectObj?.id;
      let savePromise;
      if (displayFormChildId.toString().length > 10) {
         let prepareData = {};
         result.data.fields.forEach(
            (field) =>
               (prepareData[field.id] =
                  field.value.originalValue?.value ?? field.value.originalValue),
         );
         if (fieldTechName) {
            const findField = result.data.fields.find((field) => field.id === fieldTechName);
            prepareData[fieldTechName] = item[findField.label];
         }
         prepareData[dataProjectTechName] = item[fieldProjectObj.label].id;
         savePromise = postFormData(displayFormChildId, prepareData);
      } else {
         savePromise = saveFormV2(
            displayFormChildId,
            formKey,
            transformFormValuesForRequest(KanbanScripts.convertItemToSave(item, columns)),
            item?.recordId,
            null,
            null,
         );
      }
      savePromise
         .then(() => {
            Message.destroy();
            Message.success(intl.formatMessage({ id: "global.saved" }));
         })
         .catch(() => {
            setRows(prevRows);
            Message.destroy();
            Message.error(intl.formatMessage({ id: "form.errorWhileSaving" }));
         });
   };

   const sortRenderedColumns = (renderedColumns) => {
      let sortedArray = [];

      if (widgetData.sortColumnsByName) {
         if (!renderedColumns.some(([, column = { name: "" }]) => isNaN(+column?.name))) {
            sortedArray = renderedColumns.sort(([, a = { name: "" }], [, b = { name: "" }]) => {
               return +a?.name > +b?.name ? 1 : -1;
            });
         } else {
            sortedArray = renderedColumns.sort(([, a = { name: "" }], [, b = { name: "" }]) => {
               return a?.name?.toLowerCase() > b?.name?.toLowerCase() ? 1 : -1;
            });
         }
         // checking if that dictionary type, because we want columns to be sorted by order from back, if sortColumnsByName is 'false'
      } else if (
         columns.find((column) => column.techName === viewSettings.sortColumnsBy)?.enumType ===
         "dict"
      ) {
         sortedArray = [
            ...columns
               .find((column) => column.techName == viewSettings.sortColumnsBy)
               .values.map((value) => renderedColumns.find(([id]) => id == Object.keys(value)[0])),
         ];
      }
      //After changing horizontalPlacement setRenderedColumns takes a while, so then sortedArray i filled with undefined
      if (sortedArray.findIndex((elem) => elem == undefined) != -1) {
         sortedArray = Object.entries(renderedColumns);
      }
      return viewSettings.sortColumns ? sortedArray : sortedArray.reverse();
   };

   const exportToExcelPHP = (list) => {
      getListExcel(list.listId, 1, 10000).then((res) => {
         const data = isActivePublicUser() ? res?.data?.getPublicList : res?.data?.default;
         if (data[0]) {
            const secureFileUrl = data[0].replace(/^http:/, "https:");
            window.open(secureFileUrl);
         }
      });
   };

   // setting rendered columns
   useEffect(() => {
      const { sortColumnsBy, sortRowsBy } = viewSettings;

      if (!sortColumnsBy || !sortRowsBy || rows.length === 0 || columns.length === 0) {
         setRenderedColumns([]);
         return;
      }

      async function updateRendered() {
         try {
            const rendered = await createRenderedColumns(rows, columns);
            setRenderedColumns(rendered);
         } catch {
            setRenderedColumns([]);
         }
      }

      updateRendered();
   }, [rows, columns, viewSettings]);

   // updating view settings
   useEffectPlus(() => {
      updateViewSettings();
   }, [widgetData]);

   // fetching profiles
   useEffect(() => {
      // getting url, and decoding list`s profile, into an object
      const url = new URL(window.location);
      let listProfile = JSON.parse(decodeURIComponent(url.searchParams.get("listProfile")));

      if (listProfile) {
         setSelectedProfile(listProfile?.[widgetData.id].profile);
      }

      if (!widgetData?.listId) {
         return;
      }

      try {
         if (isV3) {
            getProfiles(widgetData.listId).then((res) => {
               if (res?.data?.length > 1) {
                  setFetchedProfiles(res?.data);
               }
            });
         } else {
            getListProfiles(widgetData?.listId).then((res) => {
               if (res?.data?.getProfiles?.length > 1) {
                  setFetchedProfiles(res?.data?.getProfiles);
               }
            });
         }
      } catch (err) {
         Message.error(intl.formatMessage({ id: "global.error" }));
      }
   }, []);

   // resizing
   useEffect(() => {
      const resize = () => {
         setMobileView(() => window.matchMedia("(max-width: 766px)").matches);
      };
      window.addEventListener("resize", resize);
      resize();
      return () => window.removeEventListener("resize", resize);
   }, []);

   // getting list
   useEffect(() => {
      const handleList = async (listId, itemsPerPage, filters, profile) => {
         try {
            Message.loading(intl.formatMessage({ id: "list.fetchingData" }), 0);
            let firstPage;
            let meta;
            let data;
            const API = isV3 ? getListV3 : getListV2;
            if (isV3) {
               firstPage = await API(listId, 1, itemsPerPage, filters);
               meta = firstPage.data.meta;
               data = firstPage.data.data;
            } else {
               firstPage = await API(listId, 1, itemsPerPage, filters, profile);
               meta = firstPage.data.default.meta;
               data = firstPage.data.default.data;
            }
            const responseData = isActivePublicUser()
               ? firstPage?.data?.getPublicList
               : (firstPage?.data?.default ?? firstPage.data);
            let form;
            if (isV3) {
               form = await getFormStructure(responseData.meta.global.presenterFormId);
            } else {
               form = await getForm(
                  responseData.meta.displayFormChildId,
                  null,
                  null,
                  null,
                  null,
                  true,
               );
            }
            const formStructure = form?.data?.default?.mainForm ?? form.data;

            handleListResponse(responseData, formStructure, listId);
            // "+" works like parseInt
            if (+meta.totalPages > 1) {
               Message.destroy();
               Message.loading(intl.formatMessage({ id: "list.fetchingAdditionalData" }), 0);
               const totalPages = meta.totalPages;
               const promisesList = [];
               for (let page = 2; page <= totalPages; page++) {
                  promisesList.push(API(listId, page, itemsPerPage, filters, profile));
               }
               const listData = await Promise.all(promisesList);
               const result = [
                  ...new Set(
                     data.concat(
                        ...listData.map(
                           (response) => response.data.data ?? response.data.default.data,
                        ),
                     ),
                  ),
               ];
               const finalData = { ...responseData };
               finalData.data = result;
               handleListResponse(finalData, formStructure, listId);
            }
            Message.destroy();
         } catch (error) {
            setLoading(false);
            Message.destroy();
            Message.error(intl.formatMessage({ id: "global.error" }));
         }
      };
      if (widgetData && widgetData.listId) {
         setLoading(true);

         let connectionFilter;
         let listFilters;
         let listProfile;
         // getting url, and decoding list`s profile, into an object

         if (window?.location) {
            const url = new URL(window.location);
            const urlParams = new URLSearchParams(window.location.search);
            listFilters = JSON.parse(decodeURIComponent(urlParams.get("listFilters")));
            listProfile = JSON.parse(decodeURIComponent(url.searchParams.get("listProfile")));

            connectionFilter = getConnectionData(widgetData.id);
         }

         if (connectionFilter) {
            handleList(widgetData.listId, 100, connectionFilter);
         } else if (listFilters?.[widgetData.id] && listProfile?.[widgetData.id]) {
            // filters and profiles
            handleList(widgetData.listId, 100, listFilters[widgetData.id], selectedProfile);
         } else if (listFilters?.[widgetData.id]) {
            // only filters
            handleList(widgetData.listId, 100, listFilters[widgetData.id]);
         } else if (listProfile?.[widgetData.id]) {
            // only profiles
            handleList(widgetData.listId, 100, null, listProfile?.[widgetData.id]?.profile);
         } else {
            handleList(widgetData.listId, 100);
         }
      } else {
         setLoading(false);
      }
   }, [widgetData.listId, search]);

   return (
      <div>
         <Widget
            className="Kanban-widget"
            role={role}
            extra={
               <div className="extra-modal-buttons">
                  {widgetData.exportXLS && (
                     <p
                        className="span-style gx-text-primary icon icon-backtop"
                        onClick={() => exportToExcelPHP(widgetData)}
                     ></p>
                  )}
                  {(role === "OWNER" || role === "MODERATOR") && (
                     <SettingsModal
                        widgetName={widgetData.name}
                        widgetId={widgetData.id}
                        icon="setting"
                        deleteIcon="true"
                        children={
                           <KanbanSettingsModal
                              value={widgetData}
                              columns={columns}
                              rows={rows}
                              role={role}
                              loading={loading}
                              renderedColumns={renderedColumns}
                              areInstancesIncluded={areInstancesIncluded}
                           />
                        }
                     />
                  )}
               </div>
            }
         >
            <div className="kanbanWidget-container">
               {loading ? (
                  <div id="items-loader" className="items-loader">
                     <Spin />
                  </div>
               ) : null}
               {mobileView ? (
                  <div className="arrows-container">
                     <Button
                        buttonType="primary"
                        className="arrow-button"
                        onClick={() => KanbanScripts.scrollKanban("left", 340)}
                     >
                        <Icon_ChevronLeft fill="none" stroke="var(--btn-primaryText)" />
                     </Button>
                     <Button
                        buttonType="primary"
                        className="arrow-button"
                        onClick={() => KanbanScripts.scrollKanban("right", 340)}
                     >
                        <Icon_ChevronRight fill="none" stroke="var(--btn-primaryText)" />
                     </Button>
                  </div>
               ) : null}
               <KanbanViewSettings
                  viewSettings={viewSettings}
                  setViewSettings={setViewSettings}
                  columns={columns}
                  rows={rows}
                  settings={widgetData}
                  fetchedProfiles={fetchedProfiles}
                  selectProfil={selectProfile}
                  initialProfile={selectedProfile}
               />
               <div className="container-for-list" id={"container-for-list-" + widgetData.id}>
                  <DragDropContext
                     onDragEnd={(result) => onDragEnd(result)}
                     // onDragStart - Leave it for future.
                  >
                     {sortRenderedColumns(renderedColumns).map(([columnId, column]) => {
                        return (
                           <KanbanColumn
                              key={columnId}
                              columnId={columnId}
                              column={column}
                              columns={columns}
                              rows={rows}
                              settings={widgetData}
                              displayFormChildId={displayFormChildId}
                              saveItemValue={saveItemValue}
                              setRows={setRows}
                              actionButtons={actionButtons}
                              previewItemFormChildId={previewItemFormChildId}
                              viewSettings={viewSettings}
                           />
                        );
                     })}
                  </DragDropContext>
               </div>
            </div>
            {!loading && renderedColumns.length === 0 ? <Empty /> : null}
         </Widget>
      </div>
   );
};

export default KanbanWidget;
